module.exports = __webpack_public_path__ + "static/media/YF106_1.205caf26.jpg";